// import { useParams } from "react-router-dom";
// import vehiclesData from "../../../VehiclesData";

// const VehicleDetail = () => {
//   const { id } = useParams();
//   const vehicle = vehiclesData.find((v) => v.id === id);

//   if (!vehicle) {
//     return <h2 className="text-center text-red-500">Vehicle not found!</h2>;
//   }

//   return (
//     <div className="min-h-screen mt-16 mx-4 md:mx-20">
//       {/* Vehicle Details */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//         <div className="pt-4 md:pt-16">
//           <h1 className="text-2xl md:text-5xl font-bold text-blue-700">{vehicle.name}</h1>
//           <p className="text-gray-500 text-sm md:text-xl pt-4">{vehicle.description}</p>
//           <ul className="flex flex-wrap gap-4 pt-4">
//             {Object.entries(vehicle.specifications).map(([key, value]) => (
//               <li key={key} className="text-sm md:text-base">
//                 {value} <br />
//                 <span className="text-gray-500">{key}</span>
//               </li>
//             ))}
//           </ul>
//         </div>
//         <div className="flex justify-center">
//           <img src={vehicle.image} alt={vehicle.name} className="w-full max-w-md rounded-lg" />
//         </div>
//       </div>

//       {/* Features */}
//       <div className="w-full bg-gray-100 shadow-lg rounded-lg mt-12 p-4 md:p-8">
//         <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//           {vehicle.features?.map((feature, index) => (
//             <div key={index} className="flex flex-col items-center">
//               <img src={feature.img} alt={feature.label} className="w-12 md:w-16" />
//               <h1 className="text-sm md:text-base font-semibold">{feature.label}</h1>
//               <p className="text-xs md:text-sm text-gray-500">{feature.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VehicleDetail;

// import { useParams, useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { FiChevronLeft, FiDownload } from "react-icons/fi";

// const API_BASE = "http://localhost:5000/api/vehicles/";

// const TABS = [
//   { key: "Vehicle Information", label: "VEHICLE INFORMATION" },
//   { key: "Performance", label: "PERFORMANCE" },
//   { key: "Design & Build", label: "DESIGN & BUILD" },
//   { key: "Comfort", label: "COMFORT" },
//   { key: "Safety", label: "SAFETY" },
// ];

// const VehicleDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [vehicle, setVehicle] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [tab, setTab] = useState(TABS[0].key);
//   const [mainImageIdx, setMainImageIdx] = useState(0); // <-- add this

//   useEffect(() => {
//     async function fetchData() {
//       setLoading(true);
//       try {
//         const res = await fetch(API_BASE + id);
//         const v = await res.json();
//         setVehicle(v);
//         setMainImageIdx(0); // reset to first image if new vehicle
//       } catch {
//         setVehicle(null);
//       }
//       setLoading(false);
//     }
//     fetchData();
//   }, [id]);

//   if (loading)
//     return (
//       <div className="flex justify-center items-center min-h-[300px]">
//         <svg className="animate-spin h-8 w-8 text-blue-600" viewBox="0 0 24 24">
//           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
//         </svg>
//       </div>
//     );
//   if (!vehicle)
//     return (
//       <div className="text-center my-10 text-red-700 text-lg">Vehicle not found!</div>
//     );

//   const specs = vehicle.detailedSpecs || {};
//   const keyFeatures = vehicle.keyFeatures || [];
//   const gallery = vehicle.images || [];

//   const summaryVals = [
//     { label: "Max Power", value: vehicle.quickSpecs?.["Max Power"] },
//     { label: "Max Torque", value: vehicle.quickSpecs?.["Max Torque"] },
//     { label: "GVW", value: vehicle.quickSpecs?.["GVW"] },
//     { label: "Fuel Capacity", value: vehicle.quickSpecs?.["Fuel Capacity"] },
//   ];

//   // --- MAIN RENDER ---
//   return (
//     <div className="bg-white min-h-screen py-8 px-2 md:px-10">
//       {/* Back nav button */}
//       <button
//         onClick={() => navigate(-1)}
//         className="inline-flex items-center mb-6 px-3 py-2 text-sm text-blue-700 hover:underline"
//       >
//         <FiChevronLeft className="mr-2" /> Back to vehicles
//       </button>

//       {/* Main Image and Summary */}
//       <div className="grid md:grid-cols-2 gap-10 items-center mb-6">
//         <div>
//           <div className="flex gap-4 items-center mb-4">
//             {/* THUMBNAILS */}
//             <div className="hidden md:flex flex-col gap-2">
//               {gallery.map((img, i) => (
//                 <button
//                   key={img}
//                   type="button"
//                   onClick={() => setMainImageIdx(i)}
//                   className={`w-20 h-20 object-contain border rounded shadow focus:outline-none
//                     ${mainImageIdx === i ? "ring-2 ring-blue-500" : "opacity-80 hover:opacity-100"}
//                   `}
//                   style={{ padding: 0, borderColor: mainImageIdx === i ? "#2563eb" : "#e5e7eb" }}
//                 >
//                   <img src={img} alt={`Vehicle thumbnail ${i + 1}`} className="w-full h-full object-contain" />
//                 </button>
//               ))}
//             </div>
//             {/* MAIN IMAGE */}
//             <div className="flex-1 flex items-center justify-center">
//               <img
//                 src={gallery[mainImageIdx]}
//                 alt={vehicle.name}
//                 className="w-full max-w-md max-h-72 object-contain mx-auto"
//                 style={{ borderRadius: "18px" }}
//               />
//             </div>
//           </div>
//         </div>
//         {/* Title and Brief Summary */}
//         <div>
//           <h1 className="text-3xl font-bold text-gray-900 mb-4">{vehicle.name}</h1>
//           <div className="grid grid-cols-2 gap-4 mb-4">
//             {summaryVals.map(i =>
//               i.value ? (
//                 <div key={i.label} className="bg-gray-50 border rounded-lg p-4 text-center">
//                   <div className="text-xs text-gray-500 mb-1">{i.label}</div>
//                   <div className="text-lg font-bold text-gray-700">{i.value}</div>
//                 </div>
//               ) : null
//             )}
//           </div>
//           {vehicle.description && (
//             <div className="text-gray-700">{vehicle.description}</div>
//           )}
//         </div>
//       </div>

//       {/* Lower Section */}
//       <div className="grid md:grid-cols-3 gap-8 mb-10">
//         {/* Left: Key Features */}
//         <div className="col-span-1">
//           <div className="bg-black text-white rounded-xl p-6 mb-6">
//             <div className="font-extrabold text-lg mb-4">KEY FEATURES</div>
//             <ul className="space-y-3">
//               {keyFeatures.map(x => (
//                 <li key={x} className="flex items-center space-x-2">
//                   <span className="text-green-400 text-lg">✓</span>
//                   <span>{x}</span>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           {/* Quotation/Request Box */}
//           {/* <div className="border rounded-xl p-5 bg-white shadow">
//             <div className="font-bold text-gray-900 mb-3 text-lg">REQUEST INFORMATION</div>
//             <button className="bg-black text-white font-semibold px-4 py-2 rounded hover:bg-gray-800 transition text-sm">
//               GET QUOTATION
//             </button>
//           </div> */}
//         </div>

//         {/* Right: Specification Tabs */}
//         <div className="col-span-2">
//           <div className="flex mb-2 border-b font-bold text-sm">
//             {TABS.map((t) => (
//               <button
//                 key={t.key}
//                 className={`px-5 py-2 uppercase border-r last:border-none transition
//                   ${tab === t.key ? "bg-blue-700 text-white rounded-t" : "bg-black text-white hover:bg-blue-900"}`}
//                 onClick={() => setTab(t.key)}
//               >
//                 {t.label}
//               </button>
//             ))}
//           </div>
//           <div className="bg-white border rounded-b-lg p-4 min-h-[180px]">
//             {specs[tab] ? (
//               <table className="w-full">
//                 <tbody>
//                   {Object.entries(specs[tab]).map(([k, v]) => (
//                     <tr key={k} className="border-b last:border-none">
//                       <td className="py-2 font-medium text-gray-700">{k}</td>
//                       <td className="py-2 text-gray-900">{v}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             ) : (
//               <div className="text-gray-400 p-4">No details available.</div>
//             )}
//           </div>
//         </div>
//       </div>
//       {/* Brochure Download */}
//       {vehicle.brochure && (
//         <a
//           href={vehicle.brochure}
//           className="inline-flex items-center gap-2 text-blue-700 hover:underline mt-4"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <FiDownload /> Download Full Brochure
//         </a>
//       )}
//     </div>
//   );
// };

// export default VehicleDetails;


import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FiChevronLeft, FiDownload } from "react-icons/fi";

// const API_BASE = "http://localhost:5000/api/vehicles/";
// const API_BASE = "https://japl-backend.onrender.com/api/vehicles/";
const API_BASE = 'https://japl-backend-v2jm.onrender.com/api/vehicles/';

const TABS = [
  { key: "Vehicle Information", label: "VEHICLE INFORMATION" },
  { key: "Performance", label: "PERFORMANCE" },
  { key: "Design & Build", label: "DESIGN & BUILD" },
  { key: "Comfort", label: "COMFORT" },
  { key: "Safety", label: "SAFETY" },
];

const VehicleDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(TABS[0].key);
  const [mainImageIdx, setMainImageIdx] = useState(0);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const res = await fetch(API_BASE + id);
        const v = await res.json();
        setVehicle(v);
        setMainImageIdx(0);
      } catch {
        setVehicle(null);
      }
      setLoading(false);
    }
    fetchData();
  }, [id]);

  if (loading)
    return (
      <div className="flex justify-center items-center min-h-[300px]">
        <svg
          className="animate-spin h-8 w-8 text-blue-600"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      </div>
    );
  if (!vehicle)
    return (
      <div className="text-center my-10 text-red-700 text-lg">Vehicle not found!</div>
    );

  const specs = vehicle.detailedSpecs || {};
  const keyFeatures = vehicle.keyFeatures || [];
  const gallery = vehicle.images || [];

  const summaryVals = [
    { label: "Max Power", value: vehicle.quickSpecs?.["Max Power"] },
    { label: "Max Torque", value: vehicle.quickSpecs?.["Max Torque"] },
    { label: "GVW", value: vehicle.quickSpecs?.["GVW"] },
    { label: "Fuel Capacity", value: vehicle.quickSpecs?.["Fuel Capacity"] },
  ];

  return (
    <div className="bg-white min-h-screen py-8 px-2 sm:px-6 md:px-10 max-w-7xl mx-auto">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="inline-flex items-center mb-6 px-3 py-2 text-sm text-blue-700 hover:underline"
      >
        <FiChevronLeft className="mr-2" />
        Back to vehicles
      </button>

      {/* Main Image and summary in responsive flex */}
      <div className="flex flex-col md:flex-row gap-8 mb-6">
        {/* Image Gallery */}
        <div className="flex md:flex-col shrink-0 space-x-4 md:space-x-0 md:space-y-4 max-w-full md:max-w-[100px]">
          {gallery.map((img, i) => (
            <button
              key={img}
              type="button"
              onClick={() => setMainImageIdx(i)}
              className={`border rounded shadow focus:outline-none relative overflow-hidden ${
                mainImageIdx === i
                  ? "ring-2 ring-blue-500"
                  : "opacity-90 hover:opacity-100"
              }`}
              style={{ width: "72px", height: "72px", padding: 0 }}
              aria-label={`Show image ${i + 1}`}
            >
              <img
                src={img}
                alt={`Thumbnail ${i + 1}`}
                className="object-contain w-full h-full"
              />
            </button>
          ))}
        </div>
        {/* Main Image */}
        <div className="flex-1 flex items-center justify-center">
          <img
            src={gallery[mainImageIdx]}
            alt={vehicle.name}
            className="max-w-full max-h-72 object-contain rounded-lg"
          />
        </div>
        {/* Summary */}
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-gray-900 mb-4 text-center md:text-left">{vehicle.name}</h1>
          <div className="grid grid-cols-2 gap-6 mb-8">
            {summaryVals.map(
              (i) =>
                i.value && (
                  <div
                    key={i.label}
                    className="bg-gray-50 border rounded-lg p-4 text-center"
                  >
                    <div className="text-xs text-gray-500 mb-1">{i.label}</div>
                    <div className="text-lg font-bold text-gray-700">
                      {i.value}
                    </div>
                  </div>
                )
            )}
          </div>
          {vehicle.description && (
            <div className="text-gray-700 whitespace-pre-line">{vehicle.description}</div>
          )}
        </div>
      </div>

      {/* Lower section with grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-1 md:gap-8 mb-10">
        {/* Left: Key Features */}
        <div className="col-span-1  bg-black text-white rounded-xl p-6">
          <h2 className="font-extrabold text-lg mb-4">KEY FEATURES</h2>
          <ul className="space-y-3">
            {keyFeatures.map((feature) => (
              <li key={feature} className="flex items-center space-x-2">
                <span className="text-green-400 text-lg">✓</span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Right: Tabs for specs */}
        <div className="col-span-2">
          <div className="flex overflow-x-auto mb-2 border-b font-bold text-sm scroll-smooth no-scrollbar">
            {TABS.map((t) => (
              <button
                key={t.key}
                className={`flex-shrink-0 px-5 py-2 uppercase border-r last:border-none transition ${
                  tab === t.key
                    ? "bg-blue-700 text-white rounded-t"
                    : "bg-black text-white hover:bg-blue-700"
                }`}
                onClick={() => setTab(t.key)}
              >
                {t.label}
              </button>
            ))}
          </div>
          <div className="bg-white border rounded-b-lg p-4 min-h-[180px]">
            {specs[tab] ? (
              <table className="w-full">
                <tbody>
                  {Object.entries(specs[tab]).map(([key, value]) => (
                    <tr key={key} className="border-b last:border-none">
                      <td className="py-2 font-medium text-gray-700">{key}</td>
                      <td className="py-2 text-gray-900">{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-gray-400 p-4">No details available.</div>
            )}
          </div>
        </div>
      </div>

      {/* Brochure */}
      {vehicle.brochure && (
        <a
          href={vehicle.brochure}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-blue-700 hover:underline mt-4"
        >
          <FiDownload /> Download Full Brochure
        </a>
      )}
    </div>
  );
};

export default VehicleDetails;
